import React, { useEffect, useState } from 'react';
import { cruiseLineLogoUrl, cruiseSubBrandLogoUrl } from '../../utils/cruiseLogos';
import styles from './CruiseLineLogo.module.css';

interface CruiseLineLogoProps {
  cruiseLine: string;
  /** list = 32px (picker), sailing = 20px */
  size?: 'list' | 'sailing';
  className?: string;
}

export const CruiseLineLogo: React.FC<CruiseLineLogoProps> = ({
  cruiseLine,
  size = 'list',
  className,
}) => {
  const [failed, setFailed] = useState(false);
  const src = cruiseLineLogoUrl(cruiseLine);

  useEffect(() => {
    setFailed(false);
  }, [src]);

  if (!src || failed) return null;

  return (
    <img
      src={src}
      alt=""
      className={`${styles.logo} ${size === 'sailing' ? styles.sailing : styles.list} ${className ?? ''}`}
      onError={() => setFailed(true)}
      decoding="async"
    />
  );
};

interface CruiseSubBrandLogoProps {
  label: string;
  className?: string;
}

export const CruiseSubBrandLogo: React.FC<CruiseSubBrandLogoProps> = ({ label, className }) => {
  const [failed, setFailed] = useState(false);
  const src = cruiseSubBrandLogoUrl(label);

  useEffect(() => {
    setFailed(false);
  }, [src]);

  if (!src || failed) return null;

  return (
    <img
      src={src}
      alt=""
      className={`${styles.logo} ${styles.list} ${className ?? ''}`}
      onError={() => setFailed(true)}
      decoding="async"
    />
  );
};

export default CruiseLineLogo;
